import { useRef } from 'react';
import { useIntersection } from 'react-use';

export type TRef = HTMLDivElement & HTMLSpanElement;

export function useIsVisible<T extends HTMLElement = TRef>(options: IntersectionObserverInit = {}) {
  const ref = useRef<T>(null);
  const intersecting = useIntersection(ref, options);

  return { ref, isVisible: intersecting?.isIntersecting ?? false } as const;
}
